/* globals Lethargy, _ */

import Vue from 'vue';
import { gsap } from 'gsap/all';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

Vue.component('intro-component', {

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            //
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.discovered = false;
        EventBus.$once('page-transition-enter-complete', () => {
            if (this.$root.introduction) {
                gsap.set('.homepage-container', {
                    autoAlpha: 0,
                });

                // if (this.$root.isMobile) {
                //     this.$el.style.height = window.innerHeight + 'px';
                // }

                disableBodyScroll(document.querySelector('header'));
                this.listenForScroll();
            }
        });
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        discover() {
            this.discovered = true;
            gsap.to('.introduction-container', {
                autoAlpha: 0,
                duration: 0.5,
                onComplete: () => {
                    this.$root.introduction = false;
                    enableBodyScroll(document.querySelector('header'));
                },
            });

            gsap.to('.homepage-container', { autoAlpha: 1, duration: 0.5, delay: 0.6 });
            this.removeScrollListener();
        },

        listenForScroll() {
            this.lethargy = new Lethargy(20, 120, 0.05);

            // Cross-browser way to bind to mouse events
            window.addEventListener('mousewheel', this.onUserScroll);
            window.addEventListener('DOMMouseScroll', this.onUserScroll);
            window.addEventListener('wheel', this.onUserScroll);
            window.addEventListener('MozMousePixelScroll', this.onUserScroll);

            document.addEventListener('swiped-up', this.onUserSwipe);
        },

        removeScrollListener() {
            this.lethargy = null;

            // Cross-browser way to bind to mouse events
            window.removeEventListener('mousewheel', this.onUserScroll);
            window.removeEventListener('DOMMouseScroll', this.onUserScroll);
            window.removeEventListener('wheel', this.onUserScroll);
            window.removeEventListener(
                'MozMousePixelScroll',
                this.onUserScroll,
            );

            document.removeEventListener('swiped-up', this.onUserSwipe);
        },

        onUserSwipe() {
            if (this.discovered) {
                return;
            }

            this.scrolling = true;
            this.discover();
        },

        onUserScroll: _.throttle(function(e) {
            if (!this.lethargy) {
                return;
            }

            if (this.scrolling) {
                return;
            }

            this.scrolling = true;

            const result = this.lethargy.check(e);

            // false means it's not a scroll intent, 1 or -1 means it is
            if (result === -1) {
                this.discover();
            }
        }),
    },
});
